'use client';

import { createContext, useContext } from 'react';
import type { PopoverStore } from './popover-store';

/** The shared popover's store. Its value never changes, so reading it re-renders nothing. */
export const PopoverStoreContext = createContext<PopoverStore | undefined>(undefined);

export function usePopoverStore(): PopoverStore {
    const store = useContext(PopoverStoreContext);
    if (!store) {
        throw new Error('usePopover must be used within a PopoverProvider');
    }
    return store;
}
